<template lang="pug">
  b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
    b-card
      template(#header)
        b-form-row.align-items-center
          b-col
            b-input-group(v-if="edit_name_enabled", size="sm" )
              b-form-input.bg-white(placeholder="Nombre", v-model="answer.name", @input="name_changed = true")
              b-input-group-append
                b-button(variant="soft-primary", @click="name_changed ? updateAnswer() : edit_name_enabled = false")
                  .d-flex.align-items-center
                    span.mr-1.d-none.d-md-inline-block.text-sm Guardar
                    save-icon.icon-sm
            .d-flex.align-items-center(v-else)
              p.mb-0.d-inline-block {{ answer.name || answer._id }}
              edit3-icon.icon-md.hover-primary.pointer.text-secondary.ml-2(@click="edit_name_enabled = true")
          b-col.d-flex.align-items-center(md="auto")
            b-form-checkbox.mr-2(switch, v-model="answer.enabled", @change="updateAnswer" ) {{answer.enabled ? 'Activado' : 'Desactivado'}}
            trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy")
      b-row.justify-content-around
        b-col.mb-2.mb-md-0(md="3")
          b-form-group(label="Oración" )
            b-form-checkbox(v-for="opt in phrases", :key="opt.name", :checked="answer.phrase_type[opt.name]", @change="updateSection('phrase_type', opt.name, $event)")
              .d-flex.align-items-center
                span.mr-2 {{opt.title}}
                info-icon.icon-sm.pointer.text-info(v-b-popover.hover.top, :title="opt.content")
        b-col.mb-2.mb-md-0(md="3")
          b-form-group(label="Conocimiento")
            b-form-checkbox(v-for="opt in knowledge", :key="opt.name", :checked="answer.knowledge[opt.name]", @change="updateSection('knowledge', opt.name, $event)")
              .d-flex.align-items-center
                span.mr-2 {{opt.title}}
                info-icon.icon-sm.pointer.text-info(v-b-popover.hover.top="opt.example ? `Ejemplo: ${opt.example}` : ''", :title="opt.content")
        b-col.mb-2.mb-md-0(md="3")
          b-form-group(label="Persona")
            b-form-checkbox(v-for="opt in persons", :key="opt.name", :checked="answer.person[opt.name]", @change="updateSection('person', opt.name, $event)")
              .d-flex.align-items-center
                span.mr-2 {{opt.title}}
                info-icon.icon-sm.pointer.text-info(v-b-popover.hover.top="`Ejemplo: ${opt.example}`", :title="opt.content")
        b-col.mb-2.mb-md-0(md="3")
          b-form-group(label="Sentimiento")
            b-form-checkbox(v-for="opt in sentiments", :key="opt.name", :checked="answer.sentiment[opt.name]", @change="updateSection('sentiment', opt.name, $event)")
              .d-flex.align-items-center
                span.mr-2 {{opt.title}}
                info-icon.icon-sm.pointer.text-info(v-b-popover.hover.top="`Ejemplo: ${opt.example}`", :title="opt.content")
      b-form-group
        template(#label)
          .d-flex.justify-content-between.align-items-center
            label.mb-0 Mensajes
            b-button(variant="primary", size="sm", @click="appendMessage" )
              plus-icon.icon-sm
              span Mensaje
        b-input-group.mb-1(v-for="(message, index) in answer.messages", :key="index", size="sm" )
          b-form-textarea(placeholder="Mensaje", v-model="answer.messages[index]", rows="2", @input="updateDebounce")
          b-input-group-append
            b-button(variant="soft-danger", @click="destroyMessage(index)", :disabled="answer.loading")
              b-spinner(small, variant="primary", v-if="answer.loading")
              trash-2-icon.icon-sm(v-else)
        b-card.bg-light.d-inline-block.pr-1.overflow-hidden.mb-0(no-body, v-if="answer.file")
          .d-flex.align-items-center.my-auto
            b-img(width="50", height="50", :src="answer.file", v-if="is_image")
            span.mx-2.text-secondary.text-sm {{ getFileExt(answer.file) }}
            x-icon.icon-sm.text-danger.pointer(@click="removeFile")
        .px-3.d-flex.align-items-center(v-else)
          corner-down-right-icon.icon-sm.mr-3
          b-link.text-sm(@click="$refs.answer_file_input.click()") Adjuntar archivo o imagen
      b-form-group(label="Conectar a bloque" )
        block-connector(:next_block_id="answer.block_id", @change="updateBlock")
    input.d-none(type="file", accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv", ref="answer_file_input", @change="fileSelected")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from "lodash.debounce";
import {UploadFile} from "../helpers/upload-file";
const answersController = createNamespacedHelpers('graph_answer')

export default {
  data () {
    return {
      loading: false,
      edit_name_enabled: false,
      name_changed: false,
      phrases: [
        {name:'question', title: 'Pregunta', content: 'Selecciona esta opción cuando el usuario haga una pregunta.'},
        {name:'declaration', title: 'Declaración', content: 'Selecciona esta opción cuando el usuario haga un comentario, queja o petición.'}
      ],
      knowledge: [
        {name:'affirmative', title: 'Afirmativo', content: 'El conocimiento está estructurado en forma de afirmación', example: 'Quiero ayuda de un agente'},
        {name:'negative', title: 'Negativo', content: 'El conocimiento está estructurado en forma de negación', example: 'No tengo horarios disponibles'},
        {name:'none', title: 'No existe', content: 'No se encuentra conocimiento que haga match con la pregunta.'},
      ],
      persons: [
        {name:'first', title: 'Primera', content: 'El usuario habla sobre sí mismo en el mensaje (yo, nosotros)', example: 'Tengo una duda / queremos preguntar algo'},
        {name:'second', title: 'Segunda', content: 'El usuario habla sobre el bot o la persona a la que se dirige (tú, ustedes)', example: '¿Tienen vuelos disponibles? / Eres listo'},
        {name:'third', title: 'Tercera', content: 'El usuario hable sobre otra persona o cosa en el mensaje (él, ella, ellos, ellas, eso, esa...)', example: 'No llegó el autobús / ¿La tienda está abierta?'}
      ],
      sentiments: [
        {name:'positive', title: 'Positivo', content: 'El sentimiento detectado en el mensaje es positivo', example: 'Excelente servicio'},
        {name:'negative', title: 'Negativo', content: 'El sentimiento detectado en el mensaje es negativo', example: 'Estoy muy molesto con el servicio'},
        {name:'neutral', title: 'Neutro', content: 'El sentimiento detectado en el mensaje es neutral', example: 'Tengo un boleto para viajar'}
      ]
    }
  },
  props: {
    answer: {
      type: Object,
      default: () => {
        return {
          loading: false,
          _id: null,
          enabled: true,
          name: '',
          messages: [],
          block_id: null,
          file: null,
          phrase_type: {},
          knowledge: {},
          person: {},
          sentiment: {}
        }
      }
    }
  },
  computed: {
    ...answersController.mapState({
      answers: state => state.graph_answers
    }),
    graph_answers () {
      return this.answers.filter(el => el._id !== this.answer._id)
    },
    is_image () {
      return this.answer.file ? this.answer.file.match(/\.(jpeg|jpg|gif|png)$/) != null : false
    }
  },
  methods: {
    ...mapActions(['graph_answer/update', 'graph_answer/destroy', 'helpers/upload_file']),
    updateSection(section, name, value) {
      let self = this
      let clone = Object.assign({}, this.answer[section])
      Object.keys(this.answer[section]).forEach(key => {
        this.answer[section][key] = key === name ? value : false
      })

      let exist = this.graph_answers.find(graph_answer => {
        let aux = 0
        for (let g_key in graph_answer) {
          let obj1 = graph_answer[g_key]
          let obj2 = self.answer[g_key]
          if(typeof obj1 == 'object' && Object.keys(obj1).every(key => obj1[key] === obj2[key])) {
            aux++
          }
        }
        return aux >= 4 ? graph_answer : null
      })

      if(exist) {
        self.$message.warning('Ya existe una respuesta con esa configuración' + ` ${exist.name || ''}` )
        this.$nextTick(() => {
          Object.keys(this.answer[section]).forEach(key => {
            this.answer[section][key] = clone[key]
          })
        })
        return
      }

      this.updateAnswer()
    },
    updateAnswer () {
      this.loading = true
      let self = this
      this['graph_answer/update']({
        ...this.answer,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Respuesta actualizada')
            self.edit_name_enabled = false
          }
        }
      });
    },
    updateDebounce: _debounce(function () {
      this.updateAnswer()
    }, 1000, {leading: false, trailing: true}),
    updateBlock ({next_block_id}) {
      this.answer.block_id = next_block_id
      this.updateAnswer()
    },
    confirmDestroy () {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la respuesta? No se puede deshacer.`, {
        title: 'Eliminar respuesta de grafo',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(res => {
        if (res === true) {
          this.destroyAnswer()
        }
      })
    },
    destroyAnswer () {
      let self = this
      this.loading = true

      this['graph_answer/destroy']({
        ...this.answer,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Respuesta eliminada')
          }
        }
      })
    },
    appendMessage () {
      this.answer.messages.push('')
      this.updateAnswer()
    },
    destroyMessage (index) {
      this.answer.messages.splice(index, 1)
      this.updateAnswer()
    },
    async fileSelected (event) {
      let files = event.target.files
      let file = files[0]

      if(file) {
        if(file.size / 1000000 >= 25) {
          this.$message.warning('El archivo no debe exceder los 25 megabytes')
          return
        }
        this.loading = true
        try {
          this.answer.file = await UploadFile.call(this, file)
          this.updateAnswer()
        } catch (e) {
          this.$message.warning('No logramos subir el archivo, por favor comprueba tu conexión a internet')
        }
        this.loading = false
      }
    },
    getFileExt (url) {
      try {
        return url.split('/').pop()
      } catch (e) {
        return url
      }
    },
    removeFile () {
      this.answer.file = null
      this.updateAnswer()
    },
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
</style>
